module.exports = __webpack_public_path__ + "static/img/bg.f506038d.jpg";